import AdminLayout from '../../components/feature/AdminLayout';
import LogsTable from './components/LogsTable';

export default function LogsPage() {
  return (
    <AdminLayout>
      <LogsTable />
    </AdminLayout>
  );
}
